import allImgPaths from 'assets/images';
import ConfirmationModal from 'components/common/modal/ConfirmationModal';
import React, { useState } from 'react';
import { llmAgentConversation } from 'services/llm';
import { LLMAgentPayload } from 'types/prompt.types';
import { DEFAULT_LLM_MODEL_CONFIG } from 'utils/constant';

const aiOptions = [
    {
        name: 'Simpler',
        promptKey: 'FB_AI_ASSISTS_SIMPLER'
    },
    {
        name: 'Shorter',
        promptKey: 'FB_AI_ASSISTS_SHORTER'
    },
    {
        name: 'Longer',
        promptKey: 'FB_AI_ASSISTS_LONGER'
    },
    {
        name: 'Re-write',
        promptKey: 'FB_AI_ASSISTS_REWRITE'
    },
    {
        name: 'Casual',
        promptKey: 'FB_AI_ASSISTS_CASUAL'
    },
    {
        name: 'Professional',
        promptKey: 'FB_AI_ASSISTS_PROFESSIONAL'
    }
]

const AiOption = ({ editorText, setEditorTextFromLLM, removeItem }: any) => {
    const [isShow, setIsShow] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false)

    const handleOption = () => {
        setIsShow(!isShow);
    }

    const remove = () => {
        setShowDeleteModal(true)
        setIsShow(false);
    }

    const confirmDelete = () => {
        removeItem()
    }

    const rewriteContent = async (item: any) => {
        if (editorText) {
            setIsLoading(true)
            setIsShow(false);
            
            const payload: LLMAgentPayload = {
                model_platform: DEFAULT_LLM_MODEL_CONFIG.CHAT_PROVIDER,
                model_temperature: 0,
                prompt_key: item.promptKey,
                model_name: DEFAULT_LLM_MODEL_CONFIG.CHAT_MODEL,
                input_variables: {
                    context: "",
                    question: editorText
                },
                session_id: JSON.stringify(Date.now())
            }

            try {
                const { data } = await llmAgentConversation(payload)

                if (data?.text) setEditorTextFromLLM(data.text)
                setIsLoading(false)
            } catch (error) {
                console.log({ error })
                setIsLoading(false)
            }
        }
    }

    return (
        <>
            {
                isLoading && <div className="loader-container">
                    <div className="loader"></div>
                </div>
            }
            {
                showDeleteModal &&
                <ConfirmationModal
                    headerText={'Delete'}
                    bodyText={``}
                    setShowDeleteModal={setShowDeleteModal} confirmDelete={confirmDelete}
                />
            }
            <div className="absolute top-[calc(50%_-_20px)] right-3">
                <div className="relative group">
                    <img className='cursor-pointer on-hover-border-shadow rounded-full' src={allImgPaths.aiOption} alt="" />
                    <div className={`absolute right-full top-0 transform -translate-y-1/2 z-30 bg-white rounded-lg shadow-customShadow8 px-2 py-4 w-[150px] group-hover:block hidden `}>
                        <ul>
                            {
                                aiOptions.map((option: any, index: number) => (
                                    <li
                                        key={index}
                                        className='text-sm text-[#475467] font-interMedium mb-5 last:mb-0 px-3 hover:text-[#1E0AF5] cursor-pointer'
                                        onClick={() => rewriteContent(option)}
                                    >
                                        {option.name}
                                    </li>
                                ))
                            }
                            <li onClick={remove} className='text-sm text-[#D92D20] font-interMedium mb-6 last:mb-0 px-3 flex items-center gap-x-2 cursor-pointer'>
                                <img src={allImgPaths.closeIconRed} alt="" />
                                Remove
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AiOption;